import {api} from "@/configs";
import {defineStore} from "pinia";
import {apiUrls} from "@/constants";

import {notification} from "ant-design-vue";
import {reloadPodcast} from "@/utils/podcast";

export const usePodcastStore = defineStore("podcast", {

    state: () => {
        return {
            podcasts: [],
            pagination: {
                current_page: 1,
                last_page: 1,
                per_page: 0,
                total: 0,
            },
        };
    },

    actions: {
        async addPodcast(
            podcast = {podcast_category_id, media_item_id, title, description, author, file}
        ) {
            try {
                await api.post(apiUrls.podcast, podcast, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                await reloadPodcast();
                notification.success({message: `Podcast Added`});
                return true;
            } catch (error) {
                return false;
            }
        },
        async updatePodcast(
            podcastId,
            podcast = {podcast_category_id, media_item_id, title, description, author, file}
        ) {
            try {
                await api.post(
                    `${apiUrls.podcast}/${podcastId}`,
                    {_method: "PATCH", ...podcast},
                    {
                        headers: {
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
                await reloadPodcast();
                notification.success({message: "Podcast Updated successfully"});
                return true;
            } catch (error) {
                return false;
            }
        },
        async fetchPodcasts(query = {}) {
            try {
                const response = await api.get(apiUrls.podcast, {
                    params: { onlyRecent: true, ...query },
                });

                const res = response.data;

                // CASE 1: Laravel paginator style (data.data exists)
                if (res.data && typeof res.data === "object" && res.data.data) {
                    this.podcasts = res.data.data;
                    this.pagination = {
                        current_page: res.data.current_page || 1,
                        last_page: res.data.last_page || 1,
                        per_page: res.data.per_page || res.data.data.length || 10,
                        total: res.data.total || 0,
                    };
                }
                // CASE 2: Flat API (no nested data)
                else if (Array.isArray(res.data)) {
                    this.podcasts = res.data;
                    this.pagination = {
                        current_page: res.current_page || 1,
                        last_page: res.total_pages || 1,
                        per_page: res.data.length || 10,
                        total: (res.total_pages || 1) * (res.data.length || 10),
                    };
                }
                // CASE 3: Fallback (empty or unexpected response)
                else {
                    this.podcasts = [];
                    this.pagination = {
                        current_page: 1,
                        last_page: 1,
                        per_page: 0,
                        total: 0,
                    };
                }

                return true;
            } catch (error) {
                console.error("Error fetching podcasts:", error);
                return false;
            }
        },

        async deletePodcast(id, podcast) {
            try {
                const response = await api.delete(`${apiUrls.podcast}/${id}`);
                await reloadPodcast();
                return true;
            } catch (error) {
                return false;
            }
        },

    },
});